
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiConProprietaDialog extends Serenity.EntityDialog<UtentiProdottiConProprietaRow, any> {
        protected getFormKey() { return UtentiProdottiConProprietaForm.formKey; }
        protected getIdProperty() { return UtentiProdottiConProprietaRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiProdottiConProprietaRow.localTextPrefix; }
        protected getNameProperty() { return UtentiProdottiConProprietaRow.nameProperty; }
        protected getService() { return UtentiProdottiConProprietaService.baseUrl; }
        protected getDeletePermission() { return UtentiProdottiConProprietaRow.deletePermission; }
        protected getInsertPermission() { return UtentiProdottiConProprietaRow.insertPermission; }
        protected getUpdatePermission() { return UtentiProdottiConProprietaRow.updatePermission; }

        protected form = new UtentiProdottiConProprietaForm(this.idPrefix);

        private theSecondPropertyGrid: Serenity.PropertyGrid;
        private theSecondForm: Gamification.UtentiProdottiParametriGlobaliForm;
        private theSecondValidator: JQueryValidation.Validator;

        private badgeGrid: UtentiProdottiBadgeGrid;
        private classiGrid: UtentiProdottiClassiGrid; 
        public esperienzeGrid: UtentiProdottiEsperienzeGrid;
        private alertGrid: UtentiProdottiAlertGrid;
        private classificheGrid: UtentiProdottiClassificheGrid;

        /**
         */
        constructor() {
            super();

            /**
             * 
             */
            // entity dialogs by default creates a property grid on element with ID "PropertyGrid".
            // here we explicitly create another, the second property grid (vertical form) on element with ID "SecondPropertyGrid".
            this.theSecondPropertyGrid = new Serenity.PropertyGrid(this.byId("SecondPropertyGrid"), {
                idPrefix: this.idPrefix + "_Second_",
                items: Q.getForm(Gamification.UtentiProdottiParametriGlobaliForm.formKey).filter(x => x.name != 'IdUtenteProdotto'),
                useCategories: true
            });

            // this is just a helper to access editors if needed
            this.theSecondForm = new Gamification.UtentiProdottiParametriGlobaliForm((this.theSecondPropertyGrid as any).idPrefix);

            // initialize validator for second form
            this.theSecondValidator = this.byId("SecondForm").validate(Q.validateOptions({}));

            var selfChange = 0;

            //
            if (!Q.Authorization.hasPermission("Role:SuperAdmin")) {
                // creating another toolbar for second tab that will only save Second
                new Serenity.Toolbar(this.byId("SecondToolbar"), {
                    buttons: [{
                        cssClass: "apply-changes-button",
                        title: Q.text("Controls.EntityDialog.SaveButton"),
                        onClick: () => {
                            var id = this.getIdUtenteProdotto();
                            if (!id)
                                return;

                            if (!this.theSecondValidator.form())
                                return;

                            // prepare an empty entity to serialize second details into
                            var c = <Gamification.UtentiProdottiParametriGlobaliRow>{};
                            this.theSecondPropertyGrid.save(c);

                            Gamification.UtentiProdottiParametriGlobaliService.Update({
                                EntityId: id,
                                Entity: c
                            }, response => {
                                // reload second list just in case
                                Q.reloadLookup(Gamification.UtentiProdottiParametriGlobaliRow.lookupKey);

                                // set flag that we are triggering second select change event
                                // otherwise active tab will change to first one
                                selfChange++;
                                try {
                                    // trigger change so that second select updates its text
                                    // in case if Company Name is changed
                                    this.form.IdUtenteProdotto.element.change();
                                }
                                finally {
                                    selfChange--;
                                }

                                Q.notifySuccess("I parameri globali sono stati salvati.");
                            });

                        }
                    }]
                });
            }

            /**
             * 
             */
            //
            this.form.IdUtenteProdotto.change(e => {
                if (selfChange)
                    return;

                this.loadInnerDialogs();

            });

            /**
             * 
             */
            this.badgeGrid = new UtentiProdottiBadgeGrid(this.byId("BadgeGrid"));
            this.badgeGrid.openDialogsAsPanel = false;

            /**
             * 
             */
            this.classiGrid = new UtentiProdottiClassiGrid(this.byId("ClassiGrid"));
            this.classiGrid.openDialogsAsPanel = false;

            /**
             * 
             */
            this.esperienzeGrid = new UtentiProdottiEsperienzeGrid(this.byId("EsperienzeGrid"));
            this.esperienzeGrid.openDialogsAsPanel = false;

            /**
             * 
             */
            this.alertGrid = new UtentiProdottiAlertGrid(this.byId("AlertGrid"));
            this.alertGrid.openDialogsAsPanel = false;

            /**
             * 
             */
            //this.classificheGrid = new UtentiProdottiClassificheGrid(this.byId("ClassificheGrid"));
            //this.classificheGrid.openDialogsAsPanel = false;

            /**
             * 
             */
            this.tabs.on('tabsactivate', (e, i) => {
                this.arrange();
            });
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //Remove Button
           // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }

        /**
         * This method is a good place to update states of
         * interface elements. It is called after dialog
         * is initialized and an entity is loaded into dialog.
         * This is also called in new item mode.
         */
        protected updateInterface(): void {

            super.updateInterface();

            // finding all editor elements and setting their readonly attribute
            // note that this helper method only works with basic inputs,
            // some editors require widget based set readonly overload (setReadOnly)

           // Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);   <<------------------ Enzo

            // remove required asterisk (*)
            this.element.find('sup').hide();

            // here is a way to locate a button by its css class
            // note that this method is not available in
            // getToolbarButtons() because buttons are not
            // created there yet!
            //
            // this.toolbar.findButton('delete-button').hide();

            // entity dialog also has reference variables to
            // its default buttons, lets use them to hide delete button
            // this.deleteButton.hide();                                         <<------------------ Enzo

            // we could also hide save buttons just like delete button,
            // but they are null now as we removed them in getToolbarButtons()
            // if we didn't we could write like this:
            //
            // this.applyChangesButton.hide();
            // this.saveAndCloseButton.hide();

            // instead of hiding, we could disable a button
            //
            // this.deleteButton.toggleClass('disabled', true);

        }

        /**
         * This method is called when dialog title needs to be updated.
         * Base class returns something like 'Edit xyz' for edit mode,
         * and 'New xyz' for new record mode.
         * 
         * But our dialog is readonly, so we should change it to 'View xyz'
         */
        protected getEntityTitle(): string {

            if (!this.isEditMode()) {
                // we shouldn't hit here, but anyway for demo...
                return "How did you manage to open this dialog in new record mode?";
            }
            else {
                // entitySingular is type of record this dialog edits. something like 'Supplier'.
                // you could hardcode it, but this is for demonstration
                var entityType = super.getEntitySingular();

                // get name field value of record this dialog edits
                let name = this.getEntityNameFieldValue() || "";

                // you could use Q.format with a local text, but again demo...
                return "Visualizza i dati dell\'utente " + " (" + name + ")";
            }
        }

        /**
         * This method is actually the one that calls getEntityTitle()
         * and updates the dialog title. We could do it here too...
         */
        protected updateTitle(): void {
            super.updateTitle();

            // remove super.updateTitle() call above and uncomment 
            // below line if you'd like to use this version
            // 
            // this.dialogTitle = 'View Supplier (' + this.getEntityNameFieldValue() + ')';
        }

        /** 
         */
        getIdProdotto() {
            var IdProdotto = this.form.IdProdotto.value;

            if (IdProdotto === null)
                return null;

            return IdProdotto;
        }

        getIdUtenteProdotto() {
            var IdUtenteProdotto = this.form.IdUtenteProdotto.value;

            if (IdUtenteProdotto === null)
                return null;

            return IdUtenteProdotto;
        }

        /**
         */
        protected loadInnerDialogs() {
            var IdUtenteProdotto = this.getIdUtenteProdotto();

            /**
             * 
             */
            Serenity.TabsExtensions.setDisabled(this.tabs, 'Parametri globali', !IdUtenteProdotto);
            //
            if (!IdUtenteProdotto) {
                // no first is selected, just load an empty entity
                this.theSecondPropertyGrid.load({});
                return;
            }
            // load selected item into second form by calling SecondService
            Gamification.UtentiProdottiParametriGlobaliService.Retrieve({
                EntityId: IdUtenteProdotto
            }, response => {
                this.theSecondPropertyGrid.load(response.Entity);
            });
        }

        /**
         */
        loadEntity(entity: Gamification.UtentiProdottiConProprietaRow) {
            super.loadEntity(entity);

            this.loadInnerDialogs();
        }

        /**
         */
        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.badgeGrid.idUtenteProdotto = this.entityId;
            this.badgeGrid.idProdotto = this.form.IdProdotto.value;
            this.badgeGrid.idUtente = this.form.IdUtente.value;

            this.classiGrid.idUtenteProdotto = this.entityId;
            this.classiGrid.idProdotto = this.form.IdProdotto.value;
            this.classiGrid.idUtente = this.form.IdUtente.value;
            this.classiGrid.parent = this;

            this.esperienzeGrid.IdUtenteProdotto = this.entityId;

            this.alertGrid.IdUtenteProdotto = this.entityId;

        //    this.classificheGrid.IdUtenteProdotto = this.entityId;
        //    this.classificheGrid.IdProdotto = this.form.IdProdotto.value;
        }

        /**
         */
        getTemplate() {
            return `<div id="~_Tabs" class="s-DialogContent">
    <ul>
        <li><a href="#~_TabFirst"><span>Utente</span></a></li>
        <li><a href="#~_TabSecond"><span>Parametri globali</span></a></li>
        <li><a href="#~_TabBadge"><span>Badge</span></a></li>
         <li><a href="#~_TabClassi"><span>Classi</span></a></li>
        <li><a href="#~_TabEsperienze"><span>Missioni</span></a></li>
        <li><a href="#~_TabAlert"><span>Alert</span></a></li>

<!--
        <li><a href="#~_TabClassifiche"><span>Classifiche</span></a></li>
-->

    </ul>
    <div id="~_TabFirst" class="tab-pane s-TabFirst">
        <div id="~_Toolbar" class="s-DialogToolbar">
        </div>
        <div class="s-Form">
            <form id="~_Form" action="">
                <div class="fieldset">
                    <div id="~_PropertyGrid"></div>
                    <div class="clear"></div>
                </div>
            </form>
        </div>
    </div>
    <div id="~_TabSecond" class="tab-pane s-TabSecond">
        <div id="~_SecondToolbar" class="s-DialogToolbar">
        </div>
        <div class="s-Form">
            <form id="~_SecondForm" action="">
                <div class="fieldset">
                    <div id="~_SecondPropertyGrid"></div>
                    <div class="clear"></div>
                </div>
            </form>
        </div>
    </div>
    <div id="~_TabBadge" class="tab-pane s-TabBadge">
        <div id="~_BadgeGrid">
        </div>
    </div>
     <div id="~_TabClassi" class="tab-pane s-TabClassi">
        <div id="~_ClassiGrid">
        </div>
    </div>
    <div id="~_TabEsperienze" class="tab-pane s-TabEsperienze">
        <div id="~_EsperienzeGrid">
        </div>
    </div>
    <div id="~_TabAlert" class="tab-pane s-TabAlert">
        <div id="~_AlertGrid">
        </div>
    </div>
<!--   
    <div id="~_TabClassifiche" class="tab-pane s-TabClassifiche">
        <div id="~_ClassificheGrid">
        </div>
    </div>
-->

</div>`;
        }
    }
}